import React from "react";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { TestDriveForm } from "@/components/forms/TestDriveForm";
import { CheckCircle2 } from "lucide-react";

export default function PrenotaProva() {
  return (
    <>
      <Seo title="Ordina online SENIORCAR"
        description="Ordina online la tua SENIORCAR con il supporto del centro più vicino. Ti contattiamo per confermare disponibilità, consegna e condizioni dell'offerta."
        keywords="ordina seniorcar, prenota seniorcar online" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Ordina online" }]} /></div>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pt-6 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Ordina online</h1>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">Conferma il tuo ordine online e accedi all'offerta dedicata. Ti seguiamo passo dopo passo fino alla consegna. Nessun impegno fino alla conferma.</p>
          <ul className="mt-6 space-y-3">
            {["Offerta dedicata online", "Consulenza personalizzata", "Supporto fino alla consegna", "Informazioni su agevolazioni"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-slate-700 text-lg"><CheckCircle2 size={20} className="text-emerald-700" /> {t}</li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3"><TestDriveForm /></div>
      </section>
      <div className="h-16" />
    </>
  );
}
